import {
  globalConstants,
  initialPagination,
  countriesEcncylopediaConstants,
} from "../../constants";

const { SUCCESS, FAILURE } = globalConstants;
const {
  ALL_COUNTRIES_ENCYCLOPEDIA,
  COUNTRIES_ENCYCLOPEDIA_PAGINATION,
  GET_COUNTRY_ENCYCLOPEDIA_DETAIL_BY_ID,
} = countriesEcncylopediaConstants;

const initialState = {
  allCountriesEncyclopedia: [],
  countryEncyclopediaDetail: {},
  allCountriesEncyclopediaPagination: initialPagination,
};

export const countriesEncyclopediaReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_COUNTRIES_ENCYCLOPEDIA + SUCCESS:
      return {
        ...state,
        allCountriesEncyclopedia: action.data,
      };
    case ALL_COUNTRIES_ENCYCLOPEDIA + FAILURE:
      return {
        ...state,
        allCountriesEncyclopedia: [],
      };
    case GET_COUNTRY_ENCYCLOPEDIA_DETAIL_BY_ID + SUCCESS:
      return {
        ...state,
        countryEncyclopediaDetail: action.data,
      };
    case COUNTRIES_ENCYCLOPEDIA_PAGINATION:
      return { ...state, allCountriesEncyclopediaPagination: action.data };
    default:
      return state;
  }
};